import { __awaiter } from "tslib";
import consoleEvents from '../consoleEvents';
import { getLocale } from '../locale';
import request from '../request';
import { initLocaleFile } from './getLocaleFile';
export const FORMATTERS_KEY_PREFIX = 'hmUtilsFormatters-';
const loadFormatters = () => __awaiter(void 0, void 0, void 0, function* () {
    const locale = getLocale();
    const formattersKey = `${FORMATTERS_KEY_PREFIX}${locale}`;
    if ((sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(formattersKey)) === null) {
        try {
            const { data: formatterPatterns } = yield request.get('formatters');
            if (formatterPatterns) {
                sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(formattersKey, JSON.stringify(formatterPatterns));
            }
        }
        catch (error) {
            consoleEvents.error(error, 'Error');
        }
    }
});
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    yield Promise.all([loadFormatters(), initLocaleFile()]);
});
export default init;
//# sourceMappingURL=init.js.map